import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id"]

import { Field } from 'vee-validate';
import Calendar from 'primevue/calendar';
import { computed } from '@vue/reactivity';
import moment from 'moment';

export default /*#__PURE__*/_defineComponent({
  __name: 'CalanderWithLabel',
  props: {
    name: {},
    label: {},
    modelValue: {},
    smallLabel: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const value = computed({
    get: () => props.modelValue ? new Date(props.modelValue) : null,
    set: (val) => {
        emit('update:modelValue', val ? moment(val).add(7, 'hour').toISOString() : null);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), [
    _createVNode(_unref(Field), {
      name: _ctx.name,
      "model-value": _unref(value)
    }, {
      default: _withCtx(({ field, errorMessage }) => [
        _createElementVNode("label", { for: _ctx.name }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.smallLabel)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.smallLabel), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1),
        _createVNode(_unref(Calendar), {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          class: _normalizeClass({ 'p-invalid': errorMessage }),
          selectionMode: "single",
          "date-format": "dd/mm/yy",
          "show-icon": true,
          "show-on-focus": false
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", {
          id: `${_ctx.name}-help`,
          class: "p-error"
        }, _toDisplayString(errorMessage), 9, _hoisted_3)
      ]),
      _: 1
    }, 8, ["name", "model-value"])
  ], 16))
}
}

})